module.exports = __webpack_public_path__ + "img/bf62600.webp";